/*
 * Wuselzeit — externer Checkout
 *
 * Einbinden im Shopify-Theme (snippets/wuselzeit-checkout.liquid oder direkt
 * im Cart-Template).  Ersetzt den Standard-Checkout-Button.
 *
 * Wichtig: Hier werden AUSSCHLIESSLICH Varianten-IDs und Mengen verschickt.
 * Preise kommen serverseitig aus der Shopify Admin API. Wer hier einen Preis
 * mitschicken wollte, würde ihn ohnehin ignoriert sehen.
 */
(function () {
  'use strict';

  var ENDPOINT = window.WUSELZEIT_CHECKOUT_URL || 'https://checkout.wuselzeit.de/checkout';
  // Zwei Wege, denselben Klick abzufangen:
  //   [data-wuselzeit-checkout]  eigener Button, falls im Theme gesetzt
  //   [name="checkout"]          der native Shopify-Button
  // Der zweite ist wichtig: Themes wie Impact rendern den Warenkorb per
  // JavaScript, teils als Drawer, teils als Seite. Den Button im Theme zu
  // ersetzen hiesse, mehrere Dateien anzufassen und das bei jedem
  // Theme-Update erneut. Abfangen trifft beide Stellen auf einmal.
  var BUTTON_SELECTOR = '[data-wuselzeit-checkout], [name="checkout"]';
  var COUNTRY_SELECTOR = '[data-wuselzeit-country]';

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Warenkorb konnte nicht gelesen werden.');
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          throw new Error('Dein Warenkorb ist leer.');
        }
        return {
          // variant_id, nicht id: heute identisch, aber semantisch eindeutig.
          // key enthält zusätzlich einen Hash und wäre als Varianten-ID falsch.
          items: cart.items.map(function (item) {
            return { variant_id: item.variant_id, quantity: item.quantity };
          }),
          discountCode: aktiverRabattcode(cart)
        };
      });
  }

  // Ein Rabatt-Link (/discount/CODE) setzt den Code in Shopifys Sitzung, und
  // der Warenkorb rechnet ihn sofort an. Ohne diese Zeilen sähe der Kunde im
  // Warenkorb 279,90 € und auf der Bestellübersicht 299,90 € — der Preis
  // stiege zwischen zwei Klicks. Nichts zerstört Vertrauen schneller.
  //
  // Übertragen wird NUR der Code, nie ein Betrag. Was er wert ist, ermittelt
  // der Server bei Shopify — sonst könnte man sich den Rabatt selbst
  // aussuchen.
  function aktiverRabattcode(cart) {
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && codes[i].applicable && codes[i].code) return codes[i].code;
    }
    return null;
  }

  // Die Meta-Kennungen liegen in Cookies der SHOP-Domain. Der Checkout laeuft
  // auf einer anderen Domain und kaeme nie an sie heran — also reisen sie im
  // Request mit. Fehlt das Pixel-Script, bleibt es bei einem leeren Objekt
  // und der Checkout funktioniert unveraendert.
  function pageUrl() {
    try {
      var href = window.location && window.location.href;
      return href ? String(href).split('#')[0] : null;
    } catch (e) {
      return null;
    }
  }

  // Jeder Pfad hier ist abgesichert, auch der Notnagel. Was Meta meldet, ist
  // Beiwerk; der Kauf ist es nicht. Faellt das Tracking aus, geht der Kunde
  // trotzdem zur Kasse -- und nicht andersherum.
  function trackingSignals() {
    try {
      if (window.WuselzeitTracking && window.WuselzeitTracking.signals) {
        return window.WuselzeitTracking.signals();
      }
    } catch (e) { /* faellt auf den Notnagel unten zurueck */ }
    return { page_url: pageUrl(), consent: 'unknown' };
  }

  function selectedCountry() {
    var select = document.querySelector(COUNTRY_SELECTOR);
    return select && select.value ? select.value : 'DE';
  }

  function showError(button, message) {
    var box = document.getElementById('wuselzeit-checkout-error');
    if (!box) {
      box = document.createElement('p');
      box.id = 'wuselzeit-checkout-error';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'color:#b3261e;font-size:14px;margin:10px 0 0;';
      button.parentNode.insertBefore(box, button.nextSibling);
    }
    box.textContent = message;
  }

  function clearError() {
    var box = document.getElementById('wuselzeit-checkout-error');
    if (box) box.textContent = '';
  }

  function handleClick(button, event) {
    event.preventDefault();
    if (button.dataset.busy === '1') return;

    button.dataset.busy = '1';
    button.dataset.originalLabel = button.dataset.originalLabel || button.textContent;
    button.disabled = true;
    button.textContent = 'Einen Moment …';
    clearError();

    readCart()
      .then(function (warenkorb) {
        var signals = trackingSignals();
        return fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: warenkorb.items,
            discount_code: warenkorb.discountCode,
            shipping_country: selectedCountry(),
            fbp: signals.fbp || null,
            fbc: signals.fbc || null,
            // Unsere Besucher-ID: verbindet bei Meta Shop-Besuch und Kauf.
            besucher_id: signals.besucher_id || null,
            page_url: signals.page_url,
            consent: signals.consent
          })
        });
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.error || 'Der Checkout ist gerade nicht erreichbar.');
          return data;
        });
      })
      .then(function (data) {
        if (!data.redirect_url) throw new Error('Unerwartete Antwort vom Checkout.');

        // Derselbe Klick loest serverseitig ebenfalls ein InitiateCheckout
        // aus. Beide tragen dieselbe event_id, also zaehlt Meta genau eines —
        // und wenn ein Werbeblocker dieses hier verschluckt, bleibt das vom
        // Server uebrig.
        try {
          if (window.WuselzeitTracking && data.reference) {
            window.WuselzeitTracking.track('InitiateCheckout', {
              value: data.total_eur ? Number(data.total_eur) : undefined,
              currency: 'EUR',
              num_items: data.num_items
            }, data.reference + '-ic');
          }
        } catch (e) { /* niemals die Weiterleitung aufhalten */ }

        // Weiter zur Bestellübersicht — NICHT direkt zu Stripe.
        // Der Bestellbutton muss auf unserer Seite liegen (§ 312j Abs. 3 BGB).
        window.location.assign(data.redirect_url);
      })
      .catch(function (error) {
        button.dataset.busy = '0';
        button.disabled = false;
        button.textContent = button.dataset.originalLabel;
        showError(button, error.message || 'Da ist etwas schiefgelaufen.');
      });
  }

  // Event-Delegation statt direkter Bindung an den Button.
  //
  // Shopify-Themes rendern den Warenkorb bei jeder Mengenaenderung per AJAX
  // neu. Ein direkt gebundener Listener waere danach weg, weil der Button ein
  // anderes Element ist. Welche Events ein Theme dabei feuert, ist von Theme
  // zu Theme verschieden -- darauf kann man sich nicht verlassen. Ein
  // Listener auf document ueberlebt jedes Neu-Rendern.
  function onDocumentClick(event) {
    var target = event.target;
    while (target && target !== document) {
      if (target.matches && target.matches(BUTTON_SELECTOR)) {
        handleClick(target, event);
        return;
      }
      target = target.parentNode;
    }
  }

  // Der native Button steckt in einem Formular, das auf /checkout zeigt.
  // Ein Klick allein abzufangen genuegt nicht -- Enter im Formular oder ein
  // theme-eigener submit() wuerde sonst doch beim Shopify-Checkout landen.
  function onDocumentSubmit(event) {
    var form = event.target;
    if (!form || !form.action) return;
    if (!/\/(cart|checkout)(\?|$)/.test(form.action)) return;
    if (!form.querySelector(BUTTON_SELECTOR)) return;
    event.preventDefault();
    handleClick(form.querySelector(BUTTON_SELECTOR), event);
  }

  if (!document.documentElement.dataset.wuselzeitBound) {
    document.documentElement.dataset.wuselzeitBound = '1';
    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('submit', onDocumentSubmit, true);
  }

  window.WuselzeitCheckout = { readCart: readCart };
})();
